<template>
    <div class="TextSelect">
        <input type="hidden" :name="name" v-model="output"/>
        <input type="text" class="form-control" autocomplete="off"
            ref="TextSelect"
            :placeholder="placeholder"
            v-model="search"
            @input="onChange"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
            @keydown.enter="onEnter"
            @focus="isOpen = results.length"
            @blur="onBlur"
        />
        <ul v-show="isOpen" class="TextSelect__results">
            <li v-for="(result, i) in results" :key="i"
                :class="{
                    'TextSelect__results__item': true,
                    'TextSelect__results__item--active': i === arrowCounter
                }"
                @click="setResult(result)"
            >{{ result }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                required: true
            },
            name: {
                type: String,
                required: true
            },
            placeholder: {
                type: String,
                required: false
            },
            value: {
                type: String,
                required: false
            }
        },

        data() {
            return {
                isOpen: false,
                results: [],
                search: '',
                arrowCounter: 0,
                output: null
            };
        },

        methods: {
            onChange() {
                this.filterResults();
            },
            filterResults() {
                this.results = Object.values(this.options).filter((item) => {
                    return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                });
                this.isOpen = !! this.results.length;
            },
            setResult(result) {
                this.search = result;
                this.close();
            },
            setOutput() {
                this.output = _.findKey(this.options, (v, k) => v === this.search) || this.search;
            },
            close() {
                this.isOpen = false;
                this.arrowCounter = 0;
            },
            onArrowDown(evt) {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter -1;
                }
            },
            onEnter() {
                if (! this.isOpen) {
                    this.$refs['TextSelect'].blur();
                    return false;
                }
                this.search = this.results[this.arrowCounter];
                this.close();
            },
            onBlur() {
                let that = this;
                _.delay(function () {
                    that.setOutput();
                    that.close();
                }, 500);
            }
        },

        watch: {
            options: function (val, oldValue) {
                if (val.length !== oldValue.length) {
                    this.results = val;
                }
            }
        },

        mounted() {
            this.results = Object.values(this.options);
            this.search = this.options[this.value] || this.value;
            this.output = this.value;
        }
    };
</script>

<style>
.TextSelect {
    position: relative;
}

.TextSelect__results {
    position: absolute;
    margin: 0;
    margin-top: 5px;
    padding: 0;
    min-width: 100%;
    max-height: 200px;
    list-style: none;
    border: 1px solid #ddd;
    background-color: #fff;
    overflow: auto;
    z-index: 1000;
}

.TextSelect__results__item {
    text-align: left;
    padding: 5px 10px;
    cursor: pointer;
}

.TextSelect__results__item:hover,
.TextSelect__results:not(:hover) .TextSelect__results__item--active {
    background-color: #eee;
}
</style>
